import { adminAdd, adminUpdate, adminDelete, adminList } from '@/api'
import { roleUiToId, apiAdminToUi, creatableAdminRole } from '@/api/adapters'
import resource from '@/mock/store'
import store from '@/store'

const PAGE = { page: 1, page_size: 100 }

function currentUser() {
  return store.state.auth.user
}

function setAccountList(uiList) {
  resource.accounts.splice(0, resource.accounts.length, ...uiList)
}

function upsertAccountUi(admin) {
  const ui = apiAdminToUi(admin)
  const idx = resource.accounts.findIndex(a => a.id === ui.id)
  if (idx > -1) resource.accounts.splice(idx, 1, ui)
  else resource.accounts.push(ui)
}

async function fetchAllAdmins(params = {}) {
  const first = await adminList({ ...PAGE, ...params })
  const data = first.data || {}
  let list = data.list || []
  const total = data.total || list.length
  if (total > list.length) {
    const pages = Math.ceil(total / PAGE.page_size)
    const tasks = []
    for (let page = 2; page <= pages; page++) {
      tasks.push(adminList({ ...params, page, page_size: PAGE.page_size }))
    }
    const rest = await Promise.all(tasks)
    rest.forEach(r => {
      list = list.concat((r.data && r.data.list) || [])
    })
  }
  return list
}

/** 拉取管理员列表；接口不含超管，需合并当前登录超管 */
export async function loadAdminList(user = currentUser()) {
  const list = await fetchAllAdmins()
  const merged = list.map(apiAdminToUi)
  if (user && user.role === 'admin' && !merged.some(a => a.id === user.id)) {
    merged.unshift(user)
  }
  setAccountList(merged)
  return resource.accounts
}

function ensureSuperAdminInList(admin) {
  if (admin && Number(admin.role_id) === 1) upsertAccountUi(admin)
}

function assertCreatableRole(roleId) {
  const user = currentUser()
  const allowed = creatableAdminRole(user)
  if (!allowed) {
    throw new Error('当前账号无权限创建管理员')
  }
  const allowedId = roleUiToId(allowed)
  if (Number(roleId) !== allowedId) {
    if (user.role === 'admin') throw new Error('超级管理员只能创建总包管理员')
    if (user.role === 'general') throw new Error('总包管理员只能创建分包管理员')
    throw new Error('无权限创建该角色管理员')
  }
}

function buildAdminPayload(form, { includePassword } = {}) {
  const payload = {
    real_name: form.name.trim(),
    mobile: form.phone.trim(),
    account: form.username.trim(),
    role_id: roleUiToId(form.role)
  }
  if (includePassword) {
    payload.password = form.password || 'Abcd1234!'
  }
  const roleId = payload.role_id
  if (roleId === 2 || roleId === 3) {
    payload.company_name = (form.companyName || '').trim()
  }
  if (Array.isArray(form.projectIds)) {
    payload.project_ids = form.projectIds.map(id => Number(id)).filter(id => id > 0)
  }
  return payload
}

export async function createAccount(form, defaultPassword = 'Abcd1234!') {
  const payload = buildAdminPayload({ ...form, password: form.password || defaultPassword }, { includePassword: true })
  assertCreatableRole(payload.role_id)
  const res = await adminAdd(payload)
  await loadAdminList()
  ensureSuperAdminInList(res.data)
  return res.data
}

export async function updateAccount(form) {
  const payload = buildAdminPayload(form)
  payload.id = form.id
  if (Array.isArray(form.projectIds)) {
    payload.project_ids = form.projectIds.map(id => Number(id)).filter(id => id > 0)
  }
  const res = await adminUpdate(payload)
  await loadAdminList()
  ensureSuperAdminInList(res.data)
  return res.data
}

export async function deleteAccounts(ids) {
  await adminDelete({ ids })
  await loadAdminList()
}
